export default __webpack_public_path__ + "static/media/feedback.588b2761.svg";